export default function Donor({ name, url, imgSrc }) {
  // return (
  //   <div className="col-lg-3 col-sm-6 mb-4 mb-lg-0">
  //     <div className="media">
  //       <div className="media-body past-col-ht">
  //         {url ? (
  //           <a href={url}><h4 className="card-title h4">{name}</h4></a>
  //         ) : (
  //           <h4 className="mt-0">{name}</h4>
  //         )}
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
    <div className="col-lg-3 col-sm-6 mb-4 mb-lg-0">
      {imgSrc ? (
        // Layout WITH image
        <div className="media">
          <img
            className="mr-3 img-fluid ps-image"
            src={imgSrc.fields.file.url}
            alt={imgSrc.fields.title}
          />
          <div className="media-body">
            {url ? (
              <a href={url}>
                <h4 className="card-title h4">{name}</h4>
              </a>
            ) : (
              <h4 className="card-title h4">{name}</h4>
            )}
          </div>
        </div>
      ) : (
        // Layout WITHOUT image (your original)
        <div className="media">
          <div className="media-body past-col-ht">
            {url ? (
              <a href={url}>
                <h4 className="card-title h4">{name}</h4>
              </a>
            ) : (
              <h4 className="card-title h4">{name}</h4>
            )}
          </div>
        </div>
      )}
    </div>
  );
}